import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SubmittedApplicationListingService } from './services/submitted-application-listing.service';
import { SearchResponse } from 'src/app/angular-elements/producer/interfaces/search-response.interface';
import { Subscription } from 'rxjs';
import { ApplicationStatusRetrievalService } from 'src/app/shared/services/application-status-retrieval.service';
import { StateStructure } from '@ptl/state';
import { NgRedux } from '@ptl/angular-redux-store';
import { planDetailsByPlanId } from 'src/app/angular-elements/plan-selection/configs/reducers/plan-details.reducer';
import { PtlWindowLocationService } from '@ptl/global-components';
import { ApplicationRecord } from 'src/app/angular-elements/producer/interfaces/application-record.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { RetrieveApp } from 'src/app/shared/interfaces/application-retrieval/retrieveApp.interface';

@Component({
    selector: 'app-submitted-application-listing',
    templateUrl: './submitted-application-listing.component.html',
    styleUrls: ['./submitted-application-listing.component.scss'],
    standalone: false
})
export class SubmittedApplicationListingComponent implements OnInit, OnDestroy {

  @Input() content: { [contentKey: string]: string | boolean } = {
    planDetailsUrl: undefined,
    enrollmentContinueUrl: undefined,
    appSubmittedContentOne: undefined,
    appSubmittedContentTwo: undefined
  };
  retrievedInfo: SearchResponse;

  retrievedResponseSubscription: Subscription;
  someAppsPending: boolean;

  constructor(
    private submittedApplicationService: SubmittedApplicationListingService,
    private appStatusRetrievalService: ApplicationStatusRetrievalService,
    private ngRedux: NgRedux<StateStructure>,
    private windowLocationService: PtlWindowLocationService
  ) { }

  async ngOnInit() {
    this.retrievedResponseSubscription = this.submittedApplicationService.retrievedApps$.subscribe(response => {
      if (response) {
        this.retrievedInfo = response;
        this.someAppsPending = response.searchedApplications.some(plan => plan.portalApplicationStatus === 'IN_PROGRESS');
      }
    });
    this.submittedApplicationService.getApps();
  }

  ngOnDestroy() {
    if (this.retrievedResponseSubscription) {
      this.retrievedResponseSubscription.unsubscribe();
    }
  }

  trackByAppId(index: number, plan: ApplicationRecord): string {
    return plan.applicationTrackingId;
  }

  goToPlanDetails(planId: string) {
    console.error('function not implemented');
    this.ngRedux.dispatch(planDetailsByPlanId(planId));
    this.windowLocationService.goToUrl(this.content.planDetailsUrl as string);
  }

  async continueEnrollment(trackingId: string) {
    const valuesSaved: boolean
      = await this.appStatusRetrievalService.applyRetrievedDataToState(
        trackingId
      );

    if (valuesSaved && this.content.enrollmentContinueUrl) {
      this.windowLocationService.goToUrl(this.content.enrollmentContinueUrl as string);
    }
  }

  async getAppData(trackingId: string) {
    this.appStatusRetrievalService.getApplication(trackingId).then(appData => {
      if(appData instanceof HttpErrorResponse){
        console.error(
          `No Application Found!
          trackingId: ${trackingId}`
        );
      }
      this.retrievedInfo.searchedApplications.forEach(plan => {
        if (plan.applicationTrackingId === trackingId) {
          try {
            plan.premium = (appData as RetrieveApp).enrollementObject.enrollment.productData.monthlyPremium.toString();
            plan.planId = (appData as RetrieveApp).enrollementObject.enrollment.productData.planId;
          } catch (e) {
            console.error(e);
          }
        }
      });
    });
  }
}
